import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import OperationalBookingsTable from './OperationalBookingsTable';
import query from './getUnfulfilledBookings.graphql';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Unfulfilled bookings (no pro found)',
    component: (
      <AdminLayout>
        <OperationalBookingsTable
          query={query}
          dataKey="getUnfulfilledBookings"
          heading="Unfulfilled bookings — no pro accepted"
          emptyMsg="No unfulfilled bookings — every ordered job found a pro."
        />
      </AdminLayout>
    ),
  };
}

export default action;
